var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoursesWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.88,
    height: 18.128,
    viewBox: "0 0 21.88 18.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book_2442733",
    transform: "translate(0 -6.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110694",
    "data-name": "Path 110694",
    d: "M19.316,8.172V6h-.641A13.54,13.54,0,0,0,10.94,8.436,13.574,13.574,0,0,0,3.205,6H2.564v2.17A24.24,24.24,0,0,0,0,8.706V24.13a21.5,21.5,0,0,1,10.679-.307L10.94,24l.261-.174a21.466,21.466,0,0,1,10.679.307V8.706A24.284,24.284,0,0,0,19.316,8.172ZM1.282,22.5V9.713c.424-.1.852-.177,1.282-.245V21.386h.641a12.8,12.8,0,0,1,4.065.644,22.608,22.608,0,0,0-5.988.473Zm9.017-.465a13.3,13.3,0,0,0-6.453-1.92V7.3A12.331,12.331,0,0,1,10.3,9.55ZM11.581,9.55A12.335,12.335,0,0,1,18.034,7.3V20.117a13.3,13.3,0,0,0-6.453,1.92ZM20.6,22.5a22.608,22.608,0,0,0-5.988-.473,12.8,12.8,0,0,1,4.065-.644h.641V9.469c.43.068.858.15,1.282.245Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesWhiteIcon);
export default __webpack_public_path__ + "static/media/courses-white-icon.8bf3f089ea4ff9abe806fd7244f48d6c.svg";
export { ForwardRef as ReactComponent };